import Box from "@mui/material/Box";
import {
  gridFilteredSortedRowIdsSelector,
  useGridApiContext,
} from "@mui/x-data-grid";

import _ from "lodash";

export function GiveawayDataTableFooter(props) {
  const apiRef = useGridApiContext();
  const visableColumns = apiRef.current.getVisibleColumns();
  const filteredId = gridFilteredSortedRowIdsSelector(apiRef);
  const { rowsdata } = props;
  const filtered = _.filter(rowsdata, (rowdata) =>
    _.includes(filteredId, rowdata.invoice_id),
  );
  if (filtered.length <= 0) return;

  function Item(props) {
    const { sx, justifyContent = "flex-end", ...other } = props;
    return (
      <Box
        display="flex"
        sx={{
          p: 1,
          m: 1,
          bgcolor: (theme) => (other.children ? "grey.100" : ""),
          border: other.children ? "1px solid" : "",
          borderColor: (theme) => (other.children ? "grey.800" : ""),
          borderRadius: 2,
          fontSize: "0.875rem",
          fontWeight: "700",
          justifyContent,
          ...sx,
          fontColor: "red",
        }}
        {...other}
      />
    );
  }
  const sumOfAllGiveaway = _.sumBy(filtered, (r) =>
    Number(r.all_sum_of_giveaway),
  );
  const sumOfGiveaway = _.sumBy(filtered, (r) => Number(r.sum_of_giveaway));
  const sumOfPurchase = _.sumBy(filtered, (r) => Number(r.sum_of_purchase));

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          bgcolor: "background.paper",
          borderRadius: 1,
        }}
      >
        {_.map(visableColumns, (visableColumn) => {
          let value = "";
          let color = "";
          switch (visableColumn.field) {
            case "all_sum_of_giveaway":
              value = new Intl.NumberFormat().format(sumOfAllGiveaway);
              break;
            case "sum_of_giveaway":
              value = new Intl.NumberFormat().format(sumOfGiveaway);
              break;
            case "sum_of_purchase":
              value = new Intl.NumberFormat().format(sumOfPurchase);
              break;
            default:
              break;
          }
          return (
            <Item
              color={color}
              key={visableColumn.field}
              flex={visableColumn.flex}
              width={visableColumn.computedWidth}
            >
              {value}
            </Item>
          );
        })}
      </Box>
    </>
  );
}
